/**
 * Remove all unwanted characters.
 *
 * @param {*} inputVal Json object/ string.
 * @param {*} field Field that is needed to be strip off.
 * @param {*} regex Regular expression pattern.
 */
export default function stripOffChars(inputValue, field, regex) {
  if (typeof inputValue === 'object') {
    if (!(field in inputValue)) return inputValue;

    return {
      ...inputValue,
      [field]: (inputValue[field] || '').replace(regex, ''),
    };
  }

  if (typeof inputValue === 'string') {
    return inputValue.replace(regex, '');
  }

  return inputValue;
}
